import http from '@/lib/http';

export default http({ name: 'admin', path: '/admins' });
